// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Snackbar_wrapper__X3qyr","active":"Snackbar_active__rAPtF"};